import Swal from 'sweetalert2';
import {
    SEE_FRIEND_REQUESTS, SEE_FRIEND_LIST, SEE_BLOCKED_FRIEND_LIST, SEE_FOLLOWING_LIST, SEE_FOLLOWERS_LIST,
    IS_LOADING_FRIENDS, ACCEPT_FRIEND_REQUEST, CANCEL_FRIEND_REQUEST, IS_LOADING_FRIEND_LIST, DELETE_FRIEND,
    BLOCK_FRIEND, UNBLOCK_FRIEND, IS_LOADING_BLOCKED_FRIEND_LIST, IS_LOADING_FOLLOWING_LIST, UNFOLLOW_USER, LOAD_RELATION_BETWEEN, CHANGE_RELATION_BETWEEN, CLEAR_FRIEND_LIST, ADD_FRIEND
} from './types'
import inMemoryJWT from '../auth/inMemoryJwt';
import { urlServer } from '../config/GlobalConstant'
import localStorage from '../utils/hooks/useLocalStorage';

//friends, followers and people that I follow actions

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})

export const addFriend = (secondID, dataCurrentRelation, isProfessional) => async dispatch => {

     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"),
            secondID: secondID,
            type: 1
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud de amistad enviada'
                })
            }
            if (dataCurrentRelation) {
                
            }
            dispatch({
                type: LOAD_RELATION_BETWEEN
            })
            dispatch({
                type: CHANGE_RELATION_BETWEEN,
                payload: respJson.data.data.social
            })
        })
        .catch(error => {
            console.log()
        })

}

export const startFollow = (secondID, dataCurrentRelation, isProfessional) => async dispatch => {

     
    const accessToken = inMemoryJWT.getToken()
    

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
         
            secondID: secondID,
            type: 4
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (true || dataCurrentRelation) {
                dispatch({
                    type: LOAD_RELATION_BETWEEN
                });
                dispatch({
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Siguiendo'
                })
            }
        })
        .catch(error => {
            console.log()
        })

}

export const stopFollow = (secondID, dataCurrentRelation, isProfessional) => async dispatch => {

     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
           /*  firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"), */
            secondID: secondID,
            type: 5
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Dejando de seguir'
                })
            }
            if (false && !dataCurrentRelation) {
              /*   dispatch({
                    type: IS_LOADING_FOLLOWING_LIST
                }); */
                dispatch({
                    type: UNFOLLOW_USER,
                    payload: secondID
                })
            } else {
                dispatch({
                    type: LOAD_RELATION_BETWEEN
                });
                dispatch({
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                })
                dispatch({
                    type: UNFOLLOW_USER,
                    payload: secondID
                }) 
            }
        })
        .catch(error => {
            console.log()
        })

}

export const seeFollowingList = (id) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_FOLLOWING_LIST
    });
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social/get-social-list`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            idUser: id,
            type: 2
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: SEE_FOLLOWING_LIST,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })

}

export const seeFollowersList = (id) => async dispatch => {

     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social/get-social-list`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            idUser: id,
            type: 3
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: SEE_FOLLOWERS_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}

export const seeFriendRequests = () => async dispatch => {
    dispatch({
        type: IS_LOADING_FRIENDS
    });
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}api/social/get-requests`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            idUser: localStorage().getItem('idUser'),
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: SEE_FRIEND_REQUESTS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}


export const acceptFriendRequest = (id, dataCurrentRelation, isProfessional) => async dispatch => {

    //console.log()

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"),
            secondID: id,
            type: 2
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud aceptada'
                })
            }
            dispatch({
                type: ADD_FRIEND
            });
            if (!dataCurrentRelation) {
                dispatch({
                    type: IS_LOADING_FRIENDS
                });
                dispatch({
                    type: ACCEPT_FRIEND_REQUEST,
                    payload: id
                })
            } else {
                dispatch({
                    type: LOAD_RELATION_BETWEEN
                });
                dispatch({  
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                })
            }

        })
        .catch(error => {
            console.log()
        })

}

export const cancelFriendRequest = (id, dataCurrentRelation, isProfessional) => async dispatch => {
     console.log();
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"),
            secondID: id,
            type: 3
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log();
            if (!dataCurrentRelation) {
                dispatch({
                    type: IS_LOADING_FRIENDS
                });
                dispatch({
                    type: CANCEL_FRIEND_REQUEST,
                    payload: id
                })
            } else {
                dispatch({
                    type: LOAD_RELATION_BETWEEN
                })
                dispatch({
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                })
            }
        })
        .catch(error => {
            console.log()
        })

}
export const clearFriendList  = () =>  dispatch => {
    dispatch({
        type: CLEAR_FRIEND_LIST
    });
}
export const seeFriendList = (id) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_FRIEND_LIST
    });
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social/get-social-list`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            userId: id,
            type: 1
        })
    })
        .then(response => response.json())
        .then(respJson => {
             console.log() 
            
            if(respJson.success ){
                console.log()
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: "SEE_FRIEND_LIST",
                    payload:Object.values( respJson.data)
                });
                console.log()
               /*  Object.values(respJson.data).map((user, index) => {
                    console.log()
                }) */
            }else{
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: SEE_FRIEND_LIST,
                    payload:    []
                });
            }
           
        })
        .catch(error => {
            console.log()
            console.log()
        })

}

export const deleteFriend = (id, dataCurrentRelation, isProfessional) => async dispatch => {
    console.log()
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"),
            secondID: id,
            type: 6
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Eliminado de amigos'
                })
            }
            if (!dataCurrentRelation) {
                dispatch({
                    type: IS_LOADING_FRIEND_LIST
                });
                dispatch({
                    type: DELETE_FRIEND,
                    payload: id
                })
            } else {
                dispatch({
                    type: DELETE_FRIEND,
                    payload: id
                })
                
                dataCurrentRelation.areFriends = false
                dataCurrentRelation.sendRequestSecond = false
                dataCurrentRelation.sendRequestFirst = false
                dataCurrentRelation.requestStatus = false
                dispatch({
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                })
            }
        })
        .catch(error => {
            console.log()
        })

}

export const blockFriend = (id, dataCurrentRelation, isProfessional) => async dispatch => {
     
    const accessToken = inMemoryJWT.getToken()
      
    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"),
            secondID: id,
            type: 7
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Usuario bloqueado'
                })
            }
            if (!dataCurrentRelation) {
                dispatch({
                    type: IS_LOADING_FRIEND_LIST
                });
                
            }
            else {
                dispatch({
                    type: LOAD_RELATION_BETWEEN
                })
               /*  dispatch({
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                }) */
            }

            dispatch({
                type: BLOCK_FRIEND,
                payload: id
            })
        })
        .catch(error => {
            console.log()
        })

}

export const unblockFriend = (id, dataCurrentRelation, isProfessional) => async dispatch => {
    console.log()
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social${isProfessional ? '/professional' : '/'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem("idProfile"),
            secondID: id,
            type: 8
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Usuario desbloqueado'
                })
            }
            dispatch({
                type: IS_LOADING_BLOCKED_FRIEND_LIST
            });
            
            if (!dataCurrentRelation) {
               
               
            } else {
                dispatch({
                    type: LOAD_RELATION_BETWEEN
                })
                /* dispatch({
                    type: CHANGE_RELATION_BETWEEN,
                    payload: respJson.data.data.social
                }) */
            }

            dispatch({
                type: UNBLOCK_FRIEND,
                payload: id
            })
        })
        .catch(error => {
            console.log()
        })

}

export const seeBlockedFriendList = () => async dispatch => {
    dispatch({
        type: IS_LOADING_BLOCKED_FRIEND_LIST
    });
     
    const accessToken = inMemoryJWT.getToken()
      

    await fetch(`${urlServer}social/get-social-list`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            idUser: localStorage().getItem('idUser'),
            type: 4
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: SEE_BLOCKED_FRIEND_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}

export const followMark = (id, dataCurrentRelation) => async dispatch => {

    await fetch(`${urlServer}social/`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            firstID: localStorage().getItem("idUser"),
            secondID: id,
            type: 1
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud aceptada'
                })
            }
        })
        .catch(error => {
            console.log()
        })

}